
export default class Epg {
    constructor(tv) {
        this.tv =  tv; 
        //console.log(this.tv)       
    }
    
    getCurrentProgram()
    {
        let current = null;   
        this.tv.epg.forEach(function(item) {
            let data_odierna = new Date();
            let start = new Date(item.start);
            let end = new Date(item.end);
            if(data_odierna >= start && data_odierna <= end)
            {
                current = item;
            }
           
       });
       return current;
    }

    getNextProgram(){

        let next = null;
        var search_next = false;   
        this.tv.epg.forEach(function(item ) {
            let data_odierna = new Date();
            
            let start = new Date(item.start);
            let end = new Date(item.end);
            if(search_next == true){
                next = item
                search_next = false;
            }
            if(data_odierna >= start && data_odierna <= end)
            {
                search_next = true;
            }
           
       });
       //console.log(next);
       return next;
    }

    getAllProgram(){
        return this.tv.epg;
    }

    getFutureProgram(current = false){
        let future = [];  
        let insert = 0;      
        this.tv.epg.forEach(function(item) {
            
            let data_odierna = new Date();
            let start = new Date(item.start);
            let end = new Date(item.end);
            if (current == true){
                if(data_odierna >= start && data_odierna <= end)
                {
                    future.push(item);
                }
            }
            if(start >= data_odierna && insert < 4)
            {
                future.push(item);
                insert++;
            }
            
        });
        return future;
    }

    getAllFutureProgram(current = false){
        let future = [];      
        this.tv.epg.forEach(function(item) {
            
            let data_odierna = new Date();
            let start = new Date(item.start);
            let end = new Date(item.end);
            if (current == true){
                if(data_odierna >= start && data_odierna <= end)
                {
                    future.push(item);
                }
            }
            if(start >= data_odierna && item.title != 'Programmazione Non Disponibile')
            {
                future.push(item);
            }
            
        });
        return future;
    }

}
